import { lazy } from 'react'
import { ROUTE_PATHS } from 'constants/index'
import Home from 'games/Home'

const CrashGame = lazy(() => import('games/CrashGame/index'))
const KenoGame = lazy(() => import('games/KenoGame/index'))
const BlackjackGame = lazy(() => import('games/BlackjackGame/index'))
const HiloGame = lazy(() => import('games/HiLoGame/index'))
const RouletteGame = lazy(() => import('games/RouletteGame/index'))
const FlipCoinGame = lazy(() => import('games/FlipCoinGame/index'))

const routesList = [
  {
    path: ROUTE_PATHS.home,
    component: Home,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.crashGame,
    component: CrashGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.kenoGame,
    component: KenoGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.blackjackGame,
    component: BlackjackGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.hiloGame,
    component: HiloGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.rouletteGame,
    component: RouletteGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.flipCoinGame,
    component: FlipCoinGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  }
]

export default routesList
